<h3 class="mb-3">{{ name }}'s Assessment registration</h3>
<div class="row">
  <div class="col-md-4">
    <div class="form-group">
      <label for="name">Name</label>
      <div class="form-control readonly" [innerHTML]="name">
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label for="name">Pre Entry Number</label>
      <div class="form-control readonly" [innerHTML]="preentryNumber">
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="form-group">
      <label for="submittedAt">Submitted at</label>
      <div style="min-height: 40px;" class="form-control readonly" [innerHTML]="submittedAt | utcDate">
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
    <div class="form-group">
      <label for="submittedAt">Identity Proof</label>
      <div style="min-height: 40px;" class="form-control readonly">
        <app-application-supporting-docs [application]="application" [isPrescriber]="true" [isAros]="true" [isStudent]="true"
          [isCountersignerView]="true">
        </app-application-supporting-docs>
      </div>
    </div>
  </div>
</div>
<h3 style="margin: 30px;">Declarations by applicant</h3>

<section>
  <div class="readonly">
    <p>
      <mat-checkbox [disabled]="true" [checked]="application.declaration.isQ1Confirmed" name="registrationRegulation">
      </mat-checkbox>
      <span style="padding: 20px; text-align: justify; display: inline;">I have read, fully understand and agree to be
        bound by the
        current
        registration assessment regulations.</span>
    </p>
  </div>
  <div class="readonly">
    <p>
      <mat-checkbox [disabled]="true" [checked]="application.declaration.isQ2Confirmed" name="privacyPolicyInformation">
      </mat-checkbox><span style="padding: 20px; text-align: justify;display: inline;">I understand and accept that
        information
        provided to the GPhC as
        part of
        the application process may be used by the GPhC to determine my
        application for entry to the register, renewing my entry and assessing
        my fitness to practise, and that updated information may be requested
        for these purposes in line with the GPhC’s privacy policy.
      </span>
    </p>
  </div>
  <div class="readonly">
    <p>
      <mat-checkbox [disabled]="true" [checked]="application.declaration.isQ3Confirmed" name="correctInformation">
      </mat-checkbox><span style="padding: 20px; text-align: justify;">I declare that to the best of my knowledge all
        the information provided
        in this application is true, complete and accurate and relates to me. I
        understand that any false statement will invalidate my registration
        assessment entry.</span>

    </p>
  </div>
  <div class="readonly">
    <p>
      <mat-checkbox [disabled]="true" [checked]="application.declaration.isQ4Confirmed" name="validIdentification">
      </mat-checkbox><span style="padding: 20px; text-align: justify;">I understand that I will need to provide
        appropriate photo identification on the day of the assessment,
        as specified by Pearson VUE. I understand that I will not be permitted to sit the registration assessment
        without the correct proof of my identity.</span>

    </p>

  </div>
</section>